<template>
    <v-dialog v-model="dialog" max-width="500">
        <v-card class="v-card--dialog v-card--dialog--sm">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">주문수정</h3>
                <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body">
                <v-divider class="grey darken-4"></v-divider>
                <div class="px-8px py-12px px-md-10px py-md-16px">
                    <v-row align="center" class="row--small">
                        <v-col cols="auto">
                            <div class="pr-10px">
                                <div class="border mx-auto">
                                    <v-img :src="item?.thumb" width="120" :aspect-ratio="1/1" contain />
                                </div>
                            </div>
                        </v-col>
                        <v-col>
                            <v-row no-gutters align="center">
                                <v-col cols="12" md="auto">
                                    <v-row no-gutters align="center">
                                        <v-col cols="12">
                                            <div class="font-size-16 font-weight-medium text-truncate">{{ item?.name }}</div>
                                        </v-col>
                                        <v-col v-if="item?.type == 'option'" cols="12">
                                            <div class="font-size-14 font-size-md-16">[{{ item?.optionalNames.toString() }}] : {{ item?.optionalValues.toString() }}</div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div class="d-inline-flex align-center font-size-18 font-size-md-24">
                                                <b class="primary--text">{{ parseInt(item?.salePrice).format() }}</b><span class="font-size-16 ml-2px">원</span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
                <v-divider></v-divider>

                <div class="px-8px py-12px px-md-10px py-md-16px">
                    <optional-products v-model="cart" :product="mainProduct" @edit="ca => a(ca)"/>
                </div>
            </div>
            <div class="v-card--dialog__foot">
                <v-row class="row--x-small">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="addToCart" color="primary">확인</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>



<script>
import api from "@/api"
import OptionalProducts from "@/components/client/shop/product/optional-products.vue";

export default {
    props: ["carts"],
    data(){
        return {
            item: undefined,
            dialog: false,
            cart: [],
            mainProduct: undefined,
            _cart: undefined
        }
    },
    components: {
        OptionalProducts
    },
    methods:{
        a(ca){
            this.cart = ca
            console.log(ca)
        },
        async open(data){
            this.dialog = true
            this.item = data.product
            this._cart = data._id
            let { product } =  await api.v1.shop.products.get({_id: this.item?._mainProduct})
            this.mainProduct = product
        },
        close(){
            this.dialog = false
            this.cart = []
        },
        async addToCart(){
            if(!this.cart.length){
                return alert('변경할 옵셥값을 선택해주세요.')
            }
            let data = await api.v1.me.shop.carts.put({_id: this._cart, ...this.cart })


            console.log(data)
            this.$emit('edit', data.cart)
            this.dialog = false

            alert('상품이 변경되었습니다.')
            this.cart = []

        }
    },


}
</script>

<style scoped>
.pickup-item {
    color: #000;
}
.pickup-item input {
    border: #000 1px inset; border-radius: 4px; width: 100%; max-width: 80px; height: 30px; text-align: center;
}
</style>